/* global google_ads_settings */

// Assign the ad settings defined in the Site Settings plugin
// eslint-disable-next-line camelcase
export const googleAdsSettings = google_ads_settings;

// Ad slot configurations
export const adSlotArr = [
  {
    name: 'banner970x250',
    breakpoints: [
      [481, 0],
      [0, 480],
      [0, 0],
    ],
    primarySlot: [970, 250],
    mobSlot: [320, 150],
    slotSize: [[[970, 250]], [320, 150], [[970, 250]]],
  },
  {
    name: 'banner728x90',
    breakpoints: [
      [481, 0],
      [0, 480],
      [0, 0],
    ],
    primarySlot: [728, 90],
    mobSlot: [],
    slotSize: [[728, 90], [], [728, 90]],
  },
  {
    name: 'banner320x50',
    breakpoints: [
      [481, 0],
      [0, 480],
      [0, 0],
    ],
    primarySlot: [],
    mobSlot: [320, 50],
    slotSize: [[], [320, 50], []],
  },
  {
    name: 'banner300x600',
    breakpoints: [
      [481, 0],
      [0, 480],
      [0, 0],
    ],
    primarySlot: [300, 600],
    mobSlot: [300, 600],
    slotSize: [
      [300, 600],
      [300, 600],
      [300, 600],
    ],
  },
  {
    name: 'banner300x250',
    breakpoints: [
      [481, 0],
      [0, 480],
      [0, 0],
    ],
    primarySlot: [300, 250],
    mobSlot: [300, 250],
    slotSize: [
      [300, 250],
      [300, 250],
      [300, 250],
    ],
  },
  {
    name: 'banner2x2',
    breakpoints: [
      [768, 0],
      [0, 767],
      [0, 0],
    ],
    primarySlot: [2, 2],
    mobSlot: [2, 2],
    slotSize: [
      [2, 2],
      [2, 2],
      [2, 2],
    ],
  },
  {
    name: 'banner450x450',
    breakpoints: [
      [481, 0],
      [0, 480],
      [0, 0],
    ],
    primarySlot: [450, 450],
    mobSlot: [],
    slotSize: [[450, 450], [], [450, 450]],
  },
  {
    name: 'banner750x450',
    breakpoints: [
      [481, 0],
      [0, 480],
      [0, 0],
    ],
    primarySlot: [750, 450],
    mobSlot: [320, 480],
    slotSize: [
      [750, 450],
      [320, 480],
      [750, 450],
    ],
  },
  {
    name: 'inread1',
    primarySlot: [
      [700, 400],
      [1, 1],
      [300, 251],
    ],
    breakpoints: [
      [481, 0],
      [0, 480],
      [0, 0],
    ],
    mobSlot: [
      [320, 500],
      [1, 1],
      [300, 251],
    ],
    slotSize: [
      [
        [700, 400],
        [1, 1],
        [300, 251],
      ],
      [
        [320, 500],
        [1, 1],
        [300, 251],
      ],
      [
        [700, 400],
        [1, 1],
        [300, 251],
      ],
    ],
  },
  {
    name: 'inread2',
    primarySlot: [300, 252],
    breakpoints: [
      [481, 0],
      [0, 480],
      [0, 0],
    ],
    mobSlot: [300, 252],
    slotSize: [
      [300, 252],
      [300, 252],
      [300, 252],
    ],
  },
  {
    name: 'inread3',
    primarySlot: [300, 253],
    breakpoints: [
      [481, 0],
      [0, 480],
      [0, 0],
    ],
    mobSlot: [300, 253],
    slotSize: [
      [300, 253],
      [300, 253],
      [300, 253],
    ],
  },
  {
    name: 'inread4',
    primarySlot: [300, 254],
    breakpoints: [
      [481, 0],
      [0, 480],
      [0, 0],
    ],
    mobSlot: [300, 254],
    slotSize: [
      [300, 254],
      [300, 254],
      [300, 254],
    ],
  },
  {
    name: 'inread5',
    primarySlot: [300, 255],
    breakpoints: [
      [481, 0],
      [0, 480],
      [0, 0],
    ],
    mobSlot: [300, 255],
    slotSize: [
      [300, 255],
      [300, 255],
      [300, 255],
    ],
  },
];

// Ad slots to load immediately
export const immediateLoadSlots = ['banner970x250', 'banner320x50'];

// Configuration for refreshable ad slots
export const refreshConfig = {
  refreshEnabled: googleAdsSettings?.gpt_refresh_enabled,
  refreshInterval: Math.max(parseInt(googleAdsSettings?.gpt_refresh_interval, 10) || 30000, 0), // Time before an ad refreshes
  refreshTimerInterval: Math.max(parseInt(googleAdsSettings?.gpt_refresh_check, 10) || 1000, 100), // Time between each ad slot is checked for refresh eligibility
  refreshableAdTypes: [
    {
      name: 'banner320x50',
      minViewport: 0, // no minimum viewport restriction
      allowedTemplates: [], // empty array means allowed on all templates
    },
    {
      name: 'banner300x250',
      minViewport: 1024,
      allowedTemplates: ['single-post'],
    },
    {
      name: 'banner300x600',
      minViewport: 1024,
      allowedTemplates: ['single-post'],
    },
  ],
  maxRefreshes: Math.max(parseInt(googleAdsSettings?.gpt_refresh_max, 10) || 3, 0), // Maximum number of times an ad can be refreshed
};

// Initial state for refresh tracking
export const initialRefreshTracker = {
  refreshableSlots: new Map(),
  refreshCounts: new Map(),
  refreshTimer: null,
  visibilityState: new Map(),
  slotTypes: new Map(),
};
